import { render, staticRenderFns } from "./CreateCase.vue?vue&type=template&id=5826fcec&scoped=true&"
import script from "./CreateCase.vue?vue&type=script&lang=js&"
export * from "./CreateCase.vue?vue&type=script&lang=js&"
import style0 from "./CreateCase.vue?vue&type=style&index=0&id=5826fcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826fcec",
  null
  
)

export default component.exports